import React from 'react';
import { infoIcon } from '@chordbaker/design';

interface InfoIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({
  size = 24,
  color = '#000',
  className = ''
}) => {
  const circle = infoIcon.elements[0] as { cx: number; cy: number; r: number; stroke?: string; strokeWidth?: number | string };
  const path1 = infoIcon.elements[1] as { d: string; stroke?: string; strokeWidth?: number | string; strokeLinecap?: string };
  const path2 = infoIcon.elements[2] as { d: string; stroke?: string; strokeWidth?: number | string; strokeLinecap?: string };

  return (
    <svg
      width={size}
      height={size}
      viewBox={infoIcon.viewBox}
      fill={infoIcon.fill}
      className={className}
    >
      <circle cx={circle.cx} cy={circle.cy} r={circle.r} stroke={color} strokeWidth={circle.strokeWidth} />
      <path d={path1.d} stroke={color} strokeWidth={path1.strokeWidth} strokeLinecap={path1.strokeLinecap as React.SVGAttributes<SVGPathElement>['strokeLinecap']} />
      <path d={path2.d} stroke={color} strokeWidth={path2.strokeWidth} strokeLinecap={path2.strokeLinecap as React.SVGAttributes<SVGPathElement>['strokeLinecap']} />
    </svg>
  );
};

export default InfoIcon;
